import { Injectable } from '@angular/core';
import { DriverManagementError } from '@cordic/driver-management';
import { ErrorHandlingService, HandledError, UnhandledError } from '@cordic/request';
import { TranslateService } from '@ngx-translate/core';
import { VariableTypeEnum } from 'src/app/models/enum/variable-type.enum';

@Injectable({
  providedIn: 'root'
})
export class DriverErrorHandlingService extends ErrorHandlingService {

  constructor(private translateService: TranslateService)
  {
    super()
  }

  protected handleGeneric(error: any)
  {
    const message = this.translateService.get(`error.generic`);
    return new UnhandledError(error, message);
  }

  protected handleSpecific(errorCode: DriverManagementError): HandledError<DriverManagementError>;
  protected handleSpecific(error: string): HandledError<string>;
  protected handleSpecific(error: string | DriverManagementError)
  {
    let message;
    if (typeof error === VariableTypeEnum.STRING)
    {
      message = this.translateService.get(`error.driverManagement.${error}`) || error;
    }
    else
    {
      message = this.translateService.get(`error.driverManagement.${DriverManagementError[(error as number)]}`);
    }

    return new HandledError(error, message);
  }
}